import { Validator } from 'utils/form/validation/types';
import AddressValidator from '../Validator';
import { FIELDS } from 'components/Forms/Address/types';

export const FullAddressValidator = {
  getShape: () => {
    return AddressValidator.getShape([FIELDS.FULL_ADDRESS]);
  },
} as Validator;
